/**
 * Escapa um valor para interpolação segura em HTML (ex.: conteúdo de InfoWindow
 * do Google Maps montado via string). Evita XSS quando o dado vem da API.
 */
export const escapeHtml = (value) => {
  const str = value === null || value === undefined ? "" : String(value);
  return str
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
};

export default escapeHtml;
